import { Component, Input } from '@angular/core';
import { OmpHeadingSize, OmpImageRatio, OmpTextAlignment, OmpTextImageLayout } from '../../../_models';
import {
  OmpContentAlignmentOptions,
  OmpImageFitOptions,
  OmpImageRatioOptions,
  OmpMobileLayoutOptions,
  OmpTextImageLayoutOptions,
} from '../../order-management-portal.sections';
import { ompDesktopImageWidth, ompImageSizeHint, ompMobileImageWidth, OmpSectionSettings } from '..';

@Component({
  selector: 'omp-text-and-image-settings',
  templateUrl: './text-and-image-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpTextAndImageSettingsComponent extends OmpSectionSettings {
  public headingSize = OmpHeadingSize;
  public textAlignment = OmpTextAlignment;
  public layoutOptions = OmpTextImageLayoutOptions;
  public imageRatioOptions = OmpImageRatioOptions;
  public imageFitOptions = OmpImageFitOptions;
  public contentAlignmentOptions = OmpContentAlignmentOptions;
  public mobileLayoutOptions = OmpMobileLayoutOptions;

  @Input() contentWidth = 700;
  @Input() horizontalPadding = 32;
  @Input() pageBackground = '';
  @Input() columnCount = 1;

  get previewBackground(): string {
    let background = this.pageBackground;
    if (this.data && this.data.display_inside_card && this.data.background_color) {
      background = this.data.background_color;
    }
    return background;
  }

  get isSideBySide(): boolean {
    const layout = this.data ? this.data.layout : '';
    return layout === OmpTextImageLayout.ImageLeft || layout === OmpTextImageLayout.ImageRight;
  }

  get desktopHint(): string {
    const width = ompDesktopImageWidth({
      contentWidth: this.contentWidth,
      horizontalPadding: this.horizontalPadding,
      columnCount: this.columnCount,
      share: this.imageShare,
    });
    return ompImageSizeHint(width, this.ratio);
  }

  get mobileHint(): string {
    return ompImageSizeHint(ompMobileImageWidth(), this.ratio);
  }

  private get imageShare(): number {
    let share = 1;
    if (this.isSideBySide) {
      share = Math.max(10, Math.min(90, +this.data.image_width || 50)) / 100;
    }
    return share;
  }

  private get ratio(): string {
    return this.data ? this.data.image_ratio : OmpImageRatio.Adapt;
  }
}
